import  {__extends} from './eXcell';
import goingValidation from '../../global/goingValidationClass';
import eXcell_edn from './eXcell_edn';

function __getRelStr(value, codingType) {
    if (goingValidation.isNotEmpty(value)) {
        return ("<div class='codingDrop' value='" +
            codingType +
            "#" +
            value +
            "' datatype='" +
            codingType +
            "'>" +
            value +
            "</div>");
    }
    else {
        return "";
    }
}
var eXcell_sysCoding_ro = (function (_super) {
    __extends(eXcell_sysCoding_ro, _super);
    function eXcell_sysCoding_ro(cell) {
        _super.call(this, cell);
    }
    eXcell_sysCoding_ro.prototype.setValue = function (val) {
        //如果映射标志为true 而且 值不为空 则先插入一个字符串 然后再来进行翻译操作
        if (this.grid._getCodingMappingFlag(this.cell._cellIndex) &&
            goingValidation.isNotEmpty(val + "")) {

            val = __getRelStr(val, this.grid.getCodingType(this.cell._cellIndex));
            this.cell.innerHTML = this.grid._aplNF(val, this.cell._cellIndex);
        }
        else {
            this.cell.innerHTML = this.grid._aplNF("", this.cell._cellIndex);
        }
    };
    eXcell_sysCoding_ro.prototype.getValue = function () {
        var val = this.cell.innerHTML.toString()._dhx_trim();
        if (val.length > 0) {
            if ((val + "").indexOf("div") >= 0) {
                return $(val).text();
            }
            else {
                return val;
            }
        }
        else {
            return "";
        }
    };
    eXcell_sysCoding_ro.prototype.isDisabled = function () {
        return true;
    };
    eXcell_sysCoding_ro.prototype.edit = function () {
        return false;
    };
    return eXcell_sysCoding_ro;
})(eXcell_edn);

window.eXcell_sysCoding_ro = eXcell_sysCoding_ro;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/gridXCell/eXcell_sysCoding_ro.js